<app-breadcrumb [master]="'Narzędzia'" [parentName]="'Mailing'" [name]="'Lista'"></app-breadcrumb>
<div class="email-send-job--list-container" >
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" >

    <mat-form-field class="email-send-job--list-filter">
      <mat-label>Temat</mat-label>
      <input matInput placeholder="Nazwa" name="title" [(ngModel)]="initialFilters.title">
    </mat-form-field>

    <mat-form-field class="email-send-job--list-filter">
      <mat-label>Użytkownik</mat-label>
      <input matInput placeholder="JanKow123" name="username" [(ngModel)]="initialFilters.username">
    </mat-form-field>

    <app-datepicker
      class="email-send-job--list-filter"
      label="Data utworzenia od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.gte$requestedAt" name="gte$requestedAt"
    ></app-datepicker>

    <app-datepicker
      class="email-send-job--list-filter"
      label="Data utworzenia do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.lte$requestedAt" name="lte$requestedAt"
    ></app-datepicker>
  </form>

  <div class="email-send-job-list-buttons">
    <button (click)="filter()" mat-raised-button color="primary">
      <mat-icon>search</mat-icon> <span> Szukaj</span>
    </button>


    <button (click)="resetFilters()" mat-raised-button color="warn">
      <mat-icon>delete</mat-icon> <span> Resetuj filtry</span>
    </button>
  </div>

  <table mat-table [dataSource]="jobs" >

      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef> Data utworzenia </th>
        <td mat-cell *matCellDef="let element">
          {{element.requestedAt | date:'y-MM-dd HH:mm'}}
        </td>
      </ng-container>

      <ng-container matColumnDef="createdBy">
        <th mat-header-cell *matHeaderCellDef> Użytkownik </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="element.calledBy">
            <a class="default-link" [routerLink]="['/uzytkownicy/szczegoly', element.calledBy.uuid]">{{element.calledBy.firstName}} {{element.calledBy.lastName}}</a>
          </ng-container>
          <ng-container *ngIf="!element.calledBy">
            System
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef> Status </th>
        <td mat-cell *matCellDef="let element">
          <button *ngIf="element.status" mat-raised-button [ngClass]="element.status.color + '-button'">
            {{element.status.name}}
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="subject">
        <th mat-header-cell *matHeaderCellDef> Tytuł </th>
        <td mat-cell *matCellDef="let element">
          <a class="default-link" [routerLink]="['//wysylka-maili/szczegoly', element.mailing.uuid]">
            {{element.mailing.title}}
          </a>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>

